const topics = [
  { title: '娱乐圈大事件', desc: '年度最热明星事件全记录，从恋情曝光到离婚风波，一站式回顾', tag: '热门', color: 'bg-primary-100 text-primary-700' },
  { title: '明星八卦日报', desc: '每日最新明星动态速递，微博热搜话题一网打尽', tag: '日更', color: 'bg-accent-100 text-accent-700' },
  { title: '综艺节目追踪', desc: '热门综艺花絮、淘汰名单、选手八卦全程跟进', tag: '热追', color: 'bg-primary-100 text-primary-700' },
  { title: '影视剧透合集', desc: '最新影视剧剧情解析、幕后花絮与演员采访精选', tag: '独家', color: 'bg-accent-100 text-accent-700' },
  { title: '网络红人动态', desc: '抖音、快手、小红书头部网红日常动态与争议事件', tag: '热议', color: 'bg-primary-100 text-primary-700' },
  { title: '时尚潮流前线', desc: '明星穿搭解析、红毯造型点评与潮流品牌资讯', tag: '精选', color: 'bg-accent-100 text-accent-700' },
  { title: '海外娱乐速报', desc: '日韩欧美娱乐圈最新资讯，跨文化娱乐视角', tag: '国际', color: 'bg-primary-100 text-primary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">热门专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">精选七大吃瓜方向，总有一个你感兴趣的</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {topics.map((item, i) => (
            <a
              key={item.title}
              href={`#carousel`}
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#carousel');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.scrollY - 80;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className={`group block bg-background-100 rounded-xl p-5 cursor-pointer hover:bg-background-200/80 transition-colors ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className="flex items-start justify-between mb-3">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <span className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap ml-2 ${item.color}`}>{item.tag}</span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
                <span>进入专题</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}